import { Skeleton } from '@mui/material';
import styled from 'styled-components';

const Field = () => (
  <DetailDiv>
    <Skeleton variant="text" width="70%" height={14} />
    <Skeleton variant="text" width="90%" height={20} />
  </DetailDiv>
);

export const NotificationDetailCardSkeleton = () => (
  <Container aria-hidden="true">
    <MainContainer>
      {Array.from({ length: 8 }).map((_, index) => (
        <Field key={index} />
      ))}
    </MainContainer>
  </Container>
);

const Container = styled.div`
  border-radius: 12px;
  background-color: #f8f4f97a;
  padding: 24px;
  border: 1px solid #f8f4f9;
`;

const MainContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px;
`;

const DetailDiv = styled.div`
  min-width: 120px;
`;
